// extracted by mini-css-extract-plugin
module.exports = {"host_bg":"host-module__host_bg___9fnAf","host__title":"host-module__host__title___lLT4l","host__text":"host-module__host__text___7AB-Z"};